import React from 'react'

function Table({stats, wanted_data}) {
    let columns = [];
    let rows = [];
    let sum = []
    const {date} = stats || '';
    Object.keys(stats).forEach((item, index) => {
        columns.push(
            <th key={index}><span>{wanted_data[item]}</span></th>
        )
        if (index !== 0) {
            sum.push(    
                <td key={index}><b>{stats[item].reduce((a, b) => a+b, 0)}</b></td>
            )
        } else {
            sum.push(
                <td key={index}><b>Suma</b></td>
            )
        }
    })
    if (date)
    date.forEach((item, index) => {
        let rows_content = []
        Object.keys(stats).forEach((option, j) => {
            rows_content.push(
                <td key={Number(String(index)+String(j))}>{stats[option][index]}</td>
            )
        })
        rows.push(
            <tr key={index}>
                {rows_content}
            </tr>
        )
    })
    if (date && date.length > 0) {
        return (
            <div id="table">
            <table>
                <thead>
                    <tr>{columns}</tr>
                </thead>
                <tbody>
                    {rows}
                    <tr>{sum}</tr>
                </tbody>
            </table>
            </div>
        )
    }
}

export default Table